"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Mail, MapPin } from "lucide-react";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
function BlogGridConsumer() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {[...Array(4)].map((_, i) => <Card key={i} data-index={i} className="overflow-hidden rounded-md border-border/50 shadow-sm">
            <div className="aspect-[3/2] w-full animate-pulse bg-muted" />
            <CardContent className="flex flex-col gap-3 p-5">
              <div className="h-6 w-3/4 animate-pulse rounded-md bg-muted" />
              <div className="h-4 w-full animate-pulse rounded-md bg-muted" />
              <div className="h-4 w-2/3 animate-pulse rounded-md bg-muted" />
              <div className="mt-4 flex items-center gap-2">
                <div className="h-3 w-20 animate-pulse rounded-md bg-muted" />
                <div className="h-3 w-20 animate-pulse rounded-md bg-muted" />
              </div>
            </CardContent>
          </Card>)}
      </div>;
  }
  if (error) {
    return <div className="flex min-h-[200px] items-center justify-center rounded-md border border-dashed border-border bg-muted/30 p-8 text-center">
        <p className="text-muted-foreground">Gagal memuat laporan. Silakan coba lagi nanti.</p>
      </div>;
  }
  if (!posts || posts.length === 0) {
    return <div className="flex min-h-[200px] items-center justify-center rounded-md border border-dashed border-border bg-muted/30 p-8 text-center">
        <p className="text-muted-foreground">Belum ada laporan terkini.</p>
      </div>;
  }
  return <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
      {posts.map((post, i) => <Card key={post.id} data-index={i} className="group overflow-hidden rounded-md border-l-4 border-l-primary border-border/50 bg-card shadow-sm transition-all duration-300 hover:scale-[1.02] hover:shadow-md">
          <Link to={post.link || "#"} className="block">
            <div className="relative aspect-square w-full overflow-hidden">
              {post.featuredImage ? <img src={post.featuredImage} alt={post.title} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" loading="lazy" /> : <div className="flex h-full w-full items-center justify-center bg-muted text-muted-foreground">
                  Tanpa Gambar
                </div>}
              {post.categories && post.categories.length > 0 && <Badge className="absolute left-3 top-3 rounded-md bg-primary px-3 py-1 text-[10px] font-bold uppercase tracking-wider text-primary-foreground hover:bg-primary/90">
                  {post.categories[0].name}
                </Badge>}
            </div>
          </Link>
          <CardContent className="flex flex-col gap-3 p-5">
            <div className="flex items-center gap-1 text-primary">
              <MapPin className="h-3 w-3" />
              <span className="text-xs font-medium">Lokasi Terkini</span>
            </div>
            <h3 className="font-default text-base font-bold leading-tight text-foreground line-clamp-2">
              <Link to={post.link || "#"} className="hover:text-primary">
                {post.title}
              </Link>
            </h3>
            <div className="mt-auto flex items-center gap-2 pt-2 text-[10px] font-medium text-muted-foreground">
              {post.date && <time dateTime={post.date}>
                  {new Date(post.date).toLocaleDateString("id-ID", {
              day: "numeric",
              month: "short",
              year: "numeric",
              hour: "2-digit",
              minute: "2-digit"
            })}
                </time>}
              <span>•</span>
              <span>Baru saja</span>
            </div>
          </CardContent>
        </Card>)}
    </div>;
}
export default function LaporanDriver() {
  const wp_query_params = {
    post_type: "post",
    per_page: 4
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section data-section-id="263824" id="laporan-driver" className="bg-background py-24 text-foreground">
      <div className="container mx-auto px-4 md:px-6">
        {}
        <div className="mb-10 flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
          <div>
            <h2 className="font-default text-3xl font-bold tracking-tight text-foreground md:text-4xl">
              Laporan Driver Terkini
            </h2>
          </div>
          <Link to="#" className="inline-flex items-center rounded-md bg-primary px-6 py-2.5 text-sm font-bold text-primary-foreground transition-colors hover:bg-primary/90">
            + Kirim Laporan
          </Link>
        </div>

        {}
        <PostsProvider wp_query={{
        post_type: "post",
        per_page: 4
      }}>
          <BlogGridConsumer />
        </PostsProvider>

        {}
        <div className="mt-16 flex flex-col items-center justify-between gap-8 rounded-md bg-secondary p-8 md:p-12 lg:flex-row">
          <div className="flex w-full flex-col items-start gap-6 sm:flex-row sm:items-center lg:w-1/2">
            <div className="flex h-16 w-16 shrink-0 items-center justify-center rounded-md border border-primary/20 bg-primary/10 text-primary">
              <Mail className="h-8 w-8" strokeWidth={1.5} />
            </div>
            <div>
              <h3 className="font-default text-xl font-bold text-secondary-foreground md:text-2xl">
                Pantau Kondisi Jalan Real-Time
              </h3>
              <p className="mt-2 text-sm text-secondary-foreground/80 md:text-base">
                Dapatkan notifikasi langsung mengenai razia, kemacetan, dan kondisi jalan rusak di rute Anda.
              </p>
            </div>
          </div>
          <div className="flex w-full flex-col gap-3 sm:flex-row lg:w-1/2 lg:justify-end">
            <input type="email" placeholder="Masukkan email Anda" className="h-12 w-full rounded-md border border-border bg-background px-4 text-foreground placeholder:text-muted-foreground focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary sm:max-w-sm" required />
            <Button size="lg" className="h-12 shrink-0 rounded-md bg-primary px-8 font-bold text-primary-foreground hover:bg-primary/90">
              Berlangganan
            </Button>
          </div>
        </div>
      </div>
    </section>;
}